// Local Imports
import { layout } from "GenAlphaModel";

// Per-axis snap pitches for the routing grid derived from a stack's metal
// layers. Tracks are per-layer and per-axis: a vertical-direction layer's
// tracks are vertical lines spaced in X, so its pitch constrains X; a
// horizontal-direction layer's tracks are horizontal lines spaced in Y, so its
// pitch constrains Y. This mirrors the server routing grid in
// crates/routing/src/routing_grid (which likewise abandoned the legacy uniform
// min-pitch model so heterogeneous-pitch nodes like GF12 line up).
//
// The lowest layer in each direction is used, matching getLayerByDirection.
// Returns null when the stack lacks a layer in either direction or has a
// non-positive pitch — callers should refuse to enter routing mode (or fall
// back to the placement grid) rather than snap manual geometry onto a bogus
// lattice.
export function routingGridSnap(
  metalLayers: readonly layout.MetalLayer[]
): { snapX: number; snapY: number } | null {
  const vert = metalLayers.find((m) => m.direction === "vert");
  const horiz = metalLayers.find((m) => m.direction === "horiz");
  if (!vert || !horiz) return null;
  if (vert.pitch <= 0 || horiz.pitch <= 0) return null;
  return { snapX: vert.pitch, snapY: horiz.pitch };
}
